// extracted by mini-css-extract-plugin
module.exports = {"overlay":"LoaderWithOverlay_overlay__5gjfr","loader-container":"LoaderWithOverlay_loader-container__wdY__"};